import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { Employee } from '../../../types/Employee';
import EmployeeSearchAutocomplete from '../../common/EmployeeSearchAutocomplete/EmployeeSearchAutocomplete';
import _ from 'lodash';
import { DisableContext } from '../../../contexts/DisableContextProvider';

interface IAddEmployeeModalProps {
  open: boolean;
  alreadyAddedEmployees: string[];
  onClose: () => void;
  onAdd: (employees: Employee[]) => void;
}

export default function AddEmployeeModal({ open, alreadyAddedEmployees, onClose, onAdd }: IAddEmployeeModalProps) {
  const [selectedEmployees, setSelectedEmployees] = useState<Employee[]>([]);
  const { disabled } = useContext(DisableContext);
  useEffect(() => {
    if (!open) setSelectedEmployees([]);
  }, [open]);

  const handleAdd = () => {
    onAdd(selectedEmployees);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContentText>
        <Typography {...headerTypographyProps} sx={{ ml: 2, mt: 2 }}>
          Select Employees To Add
        </Typography>
        <Typography sx={{ ml: 2, mt: 1 }}>Please select the employees you would like to associate with this event.</Typography>
      </DialogContentText>
      <DialogContent>
        <EmployeeSearchAutocomplete<true>
          isDisabled={disabled}
          excludedEmployees={alreadyAddedEmployees}
          value={selectedEmployees}
          onChange={setSelectedEmployees}
          isMultiple
        />
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', mx: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={_.isEmpty(selectedEmployees)} onClick={handleAdd}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
